import Slider from "react-slick";

import Col from "react-bootstrap/Col";
function Carousel() {
	return (
		<>
			<Col md={7}>
				<div className="login-main-right bg-white p-5 mt-5 mb-5">
					<AuthScreenSlider />
				</div>
			</Col>
		</>
	);
}

function AuthScreenSlider() {
	var settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		initialSlide: 0,
		swipeToSlide: true,
		autoplay: false,
		autoplaySpeed: 2000,
		arrows: false,
	};
	return (
		<>
			<Slider {...settings}>
				<Slide
					heading="Personalized"
					imgSrc="/img/Slide1.png"
					imgAlt="LOGO"
				>
					Create a full replay video of ANY car in the race.
				
				</Slide>

				<Slide
					heading="Automated"
					imgSrc="/img/Slide2.png"
					imgAlt="LOGO"
				>
					 AI powered zoom, pan, and fade. No humans needed.
				</Slide>

				<Slide
					heading="Customized"
					imgSrc="/img/Slide3.png"
					imgAlt="LOGO"
				>
					Overlay in-car footage and computer data.

				</Slide>
			</Slider>
		</>
	);
}

function Slide({ imgSrc, imgAlt, heading, children }) {
	return (
		<>
			<div className="item">
				<div className="carousel-login-card text-center">
					<img src={imgSrc} className="img-fluid" alt={imgAlt} />
					<h5 className="mt-5 mb-3">​{heading}</h5>
					<p className="mb-4">{children}</p>
				</div>
			</div>
		</>
	);
}

export default Carousel;
